import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { ActivatedRoute } from '@angular/router';
import { Order } from '../../../models/orderModel';
import { BookingSummaryCardComponent } from '../booking-summary-card/booking-summary-card.component';
import { Router } from '@angular/router';
import { BookingConfigService } from '../../services/booking-config.service';
import { CheckoutServices } from '../../services/checkout.service';
import { TopNavbarComponent } from '../../organizations/components/top-navbar/top-navbar.component';
import { FormService } from '../../organizations/features/booking/components/form/service';
import { FormGroup } from '@angular/forms';
import { HandleBookingService } from '../../services/handle-booking.service';
import { ParkingRepo } from '../../repo/parking.repo';
import { BookingPriceService } from '../../services/booking-price.service';
import { BASE64_FLYGETS_LOGO } from '../../../../assets/base64-logos/flygets-logo';
import { BASE64_SKAVSTA_LOGO } from '../../../../assets/base64-logos/skavsta-logo';
import { MatDialog } from '@angular/material/dialog';
import { OrderStatusModalComponent } from '../order-status-modal/order-status-modal.component';
import { BASE64_QUALITY_LOGO } from '../../../../assets/base64-logos/quality-logo';
import { SelfServiceService } from '../../../services/self-service.service';

@Component({
  selector: 'app-receipt',
  imports: [TranslocoModule, BookingSummaryCardComponent, TopNavbarComponent, OrderStatusModalComponent],
  templateUrl: './receipt.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './receipt.component.scss',
})
export class GeneralReceiptComponent {
  order: Order | null = null;
  orderId!: string;
  parkingOrder: any = null;
  googleMapsLink: string | null = null;
  site: string = '';
  freeShuttles = false;
  optionsConfig: any;
  form !: FormService
  details !: FormGroup;
  parkingFrom !: any;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  additionalServices: any;
  parkingType!: string;
  booking: any = null;
  bookingLoaded: boolean = false;
  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  activeLang: string = 'sv';
  base64FlygetsLogo = BASE64_FLYGETS_LOGO;
  base64SkavstaLogo = BASE64_SKAVSTA_LOGO;
  base64QualityLogo = BASE64_QUALITY_LOGO;

  productsToGoogleMapsMap: any = {
    '0238073b-9b1c-437b-a304-b1dc00eff182': "https://maps.app.goo.gl/HvGKsAaYEdHXxTnD9", //SP1
    '5b6f2513-242d-4efe-b3d0-b1dc00b65e50': "https://maps.app.goo.gl/DUTzjGmA9asDWG2m9", //SHKP
    '1e40227b-d15b-4fc4-bf15-b1dc00f03a51': 'https://maps.app.goo.gl/cb2X6ULTf8n6Uvig8', //SP2
    '1a8879f4-a294-455b-97eb-b16f00e5e30a': 'https://maps.app.goo.gl/cb2X6ULTf8n6Uvig8', //SP2EL
    '5d2c7728-6944-45a6-a64e-b16f00e5e3b3': 'https://maps.app.goo.gl/oLR4YJu35L5Ru4bFA' //SP3
  }
  handleBookingGroup: any;
  email: string;
  bookingNumber: any;
  pricingService: BookingPriceService;
  isParkingPermitUser: boolean = false;
  orgId: string;

  constructor(
    public checkoutService: CheckoutServices,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private bookingConfigService: BookingConfigService,
    private route: ActivatedRoute,
    private handleBookingService: HandleBookingService,
    private _formService: FormService,
    private parkingRepo: ParkingRepo,
    private translocoService: TranslocoService,
    public dialog: MatDialog,
    private selfService: SelfServiceService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.orgId = config.orgId;

    if (this.site == 'quality hotel arlanda xpo parkering' || this.site == 'quality-xpo-arlanda' || this.site == 'quality') {
      this.site = 'quality';
    }

    if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
      this.site = "aiden"
    }

    this.freeShuttles = config.freeShuttles;
    handleBookingService.initForm(this.site);
    if ('options' in config) {
      const env: any = config;
      if ('confirmation' in env.options) {
        this.optionsConfig = env.options.confirmation;
      }
    }

    this._formService.initForm(this.site);
    this.pricingService = inject(BookingPriceService);

    this.form = this._formService;
    this.details = this.form.getForm().get('details');
    this.parkingGroup = this.form.getForm().get('parkingGroup');
    this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls?.departureHotel?.value;
    this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls?.arrivalHotel?.value;
    this.handleBookingGroup = handleBookingService.getForm().get('details');
  }

  ngOnInit(): void {
    sessionStorage.removeItem('isFromCustomerHome');
    sessionStorage.removeItem('selectedParkingFromSearch');
    if (this.site?.includes('quality') && localStorage.getItem('quality-public') === 'true') {
      this.router.navigate(['parkifly/quality-landing-page'], { queryParams: { public: 'true' } });
    } else if (this.site?.includes('aiden') && localStorage.getItem('aiden-public') === 'true') {
      this.router.navigate(['parkifly/aiden-landing-page'], { queryParams: { public: 'true' } });
    } else {
      localStorage.removeItem('quality-public');
      localStorage.removeItem('aiden-public');
      this.getOrderId();
      this.route.paramMap.subscribe(params => {
        this.bookingConfigService.setOrganizationFromUrl();
        let config = this.bookingConfigService.getConfig();
        this.site = config.site;
        this.freeShuttles = config.freeShuttles;
      });
      this.activeLang = this.translocoService.getActiveLang();
      this.translocoService.langChanges$.subscribe((lang) => {
        this.activeLang = lang;
      });
    }
  }

  getOrderId(): Promise<void> {
    return new Promise((resolve) => {
      this.activatedRoute.params.subscribe(params => {
        this.orderId = params['orderId'];
      });
      this.getOrder();
      resolve();
    });
  }

  getOrder() {
    this.checkoutService.getOrder(this.orderId).subscribe(order => {
      this.bookingDetails.order = order;

      this.email = order?.customer?.email;
      this.bookingNumber = order?.orderNr;

      if (this.email && this.bookingNumber) {
        this.handleBookingService.getBookingDetails(this.email, this.bookingNumber).subscribe(
          {
            next: ((bookingDetails) => {

              this.site = bookingDetails.organizationName?.toLowerCase();
              if (this.site == "flygets.se" || this.site == "ving") {
                this.site = "flygets";
              }
              if (this.site == "p2 utomhus") {
                this.isParkingPermitUser = true;
                this.site = "skavsta";
              }

              if (this.site == 'quality hotel arlanda xpo parkering' || this.site == 'quality-xpo-arlanda' || this.site == 'quality') {
                this.site = 'quality';
              }

              if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.site = "aiden"
              }

              if (bookingDetails.orderStatus == "Checkout" || bookingDetails.orderStatus == "CheckoutAdditional" ||
                bookingDetails.orderStatus == "DriveUp") {
                this.router.navigate(['parkifly', this.site, 'checkout', 'payment', bookingDetails.orderId]);
              }

              if (bookingDetails.orderStatus == "Cancelled") {
                this.openConfirmModal();
              }

              this.orderId = bookingDetails.orderId;
              this.booking = bookingDetails;

              if (this.booking != null) {
                setTimeout(() => {
                  this.bookingLoaded = true;
                }, 1000);
              }

              const driveUpData = localStorage.getItem('driveUpData') ? JSON.parse(localStorage.getItem('driveUpData')) : null;

              if (driveUpData?.orderId == this.orderId) {
                this.selfService.driveUpPaymentIsDone(driveUpData?.gateId, this.orderId).then((result: any) => {
                  if (result == true) {
                    localStorage.removeItem('driveUpData');
                  }
                })
              }

              this.handleBookingService.getForm().get('details').controls['cellular'].setValue(bookingDetails.cellular ?? '');
              this.handleBookingService.getForm().get('details').controls['regNr'].setValue(bookingDetails.carRegNumber ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].setValue(bookingDetails.email ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].disable();
              if (this.booking?.arrival?.terminalName == 'Terminal 5') {
                this.booking.arrival.terminalName = 'Terminal 4'
              }
              if (this.booking?.departure?.terminalName == 'Terminal 5') {
                this.booking.departure.terminalName = 'Terminal 4'
              }
              if (this.site === 'skavsta' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality-xpo-arlanda' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.handleBookingService.getForm().get('details')?.controls['persons']?.setValue(bookingDetails?.passengers?.toString());
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'flygets') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFromActual;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);

                const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
                  ? bookingDetails.additionalServices.filter((e: any) => e.status === 'Paid')
                  : [];
                if (additionalServicesArray.length > 0) {
                  additionalServicesArray.forEach(function (element: any, index: any) {
                    if (typeof element.name === 'string') {
                      element.name = JSON.parse(element.name);
                    }
                    if (typeof element.description === 'string') {
                      element.description = JSON.parse(element.description);
                    }
                    if (element.amount && element.vatAmount) {
                      element.amount = element.amount + element.vatAmount;
                    }
                  });
                }
                this.bookingDetails.additionalServices = additionalServicesArray;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'mdpark') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);
              }
            })
          }
        );
      }

    });
  }

  openConfirmModal() {
    const dialogRef = this.dialog.open(OrderStatusModalComponent, {
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/start']);
      }
    });
  }

  goToHomePage() {
    if (this.site == 'skavsta') {
      window.location.href = 'https://www.skavsta.se/';
    } else {
      this.router.navigate(['/']);
    }
  }

  goToHandleBookingForm() {
    let email = this.bookingDetails.order?.customer.email;
    let booking_number = this.bookingDetails.order?.orderNr;
    if (email && booking_number) {
      this.router.navigate(['parkifly/handle-booking/details', { email, booking_number }]);
    }
  }

  downloadPdf() {
    this.checkoutService.downloadReceipt(this.orderId).subscribe(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'receipt.pdf';
      a.click();
    });
  }

}
